export default __webpack_public_path__ + "static/media/kuulolaitehuolto.3958557f.svg";